import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './MobileMenu.css';

const MobileMenu = ({ servicesInfo = [] }) => {
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    // 监听滚动事件
    useEffect(() => {
        if (!isHomePage) {
            setIsScrolled(false);
            return;
        }

        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsScrolled(scrollTop > 100); // 当滚动超过100px时显示"回顶部"
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // 初始检查

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isHomePage]);

    // 查找"留學教育"和"香港生活服務"
    const studyService = servicesInfo.find(s => s.id === 'study');
    const crossBorderService = servicesInfo.find(s => s.id === 'crossBorder');

    const handleHomeClick = () => {
        if (isHomePage && isScrolled) {
            // 滚动回顶部
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            navigate('/');
        }
        setIsServicesOpen(false);
    };

    const handleServicesClick = () => {
        setIsServicesOpen(!isServicesOpen);
    };

    const handleServiceItemClick = (toURL) => {
        navigate(toURL);
        setIsServicesOpen(false);
    };

    const handleAboutClick = () => {
        navigate('/about');
        setIsServicesOpen(false);
    };

    return (
        <>
            <div 
                className={`mobile-menu-overlay ${isServicesOpen ? 'active' : ''}`} 
                onClick={() => setIsServicesOpen(false)}
                style={{ display: isServicesOpen ? 'block' : 'none' }}
            ></div>
            
            <div className="mobile-menu">
                <button 
                    className="mobile-menu-btn"
                    onClick={handleHomeClick}
                    aria-label={isHomePage && isScrolled ? "回顶部" : "首頁"}
                >
                    <i className={isHomePage && isScrolled ? "fas fa-arrow-up" : "fas fa-home"}></i>
                    <span>{isHomePage && isScrolled ? "回顶部" : "首頁"}</span>
                </button>

                <div className="mobile-menu-services-wrapper">
                    <button 
                        className={`mobile-menu-btn ${isServicesOpen ? 'active' : ''}`}
                        onClick={handleServicesClick}
                        aria-label="服務"
                    >
                        <i className="fas fa-briefcase"></i>
                        <span>服務</span>
                    </button>

                    {/* 浮动服务按钮 - 只在 isServicesOpen 时显示 */}
                    {isServicesOpen && (
                        <>
                            {studyService && (
                                <button
                                    className="mobile-menu-floating-btn mobile-menu-floating-btn-study"
                                    onClick={() => handleServiceItemClick(
                                        studyService.introduction?.toURL || `/study`
                                    )}
                                    aria-label={studyService.label || '留學教育'}
                                >
                                    <i className="fas fa-graduation-cap"></i>
                                    <span>{studyService.label || '留學教育'}</span>
                                </button>
                            )}
                            {crossBorderService && (
                                <button
                                    className="mobile-menu-floating-btn mobile-menu-floating-btn-crossborder"
                                    onClick={() => handleServiceItemClick(
                                        crossBorderService.introduction?.toURL || `/crossBorder`
                                    )}
                                    aria-label={crossBorderService.label || '香港生活服務'}
                                >
                                    <i className="fas fa-building"></i>
                                    <span>{crossBorderService.label || '香港生活服務'}</span>
                                </button>
                            )}
                        </>
                    )}
                </div>

                <button 
                    className="mobile-menu-btn"
                    onClick={handleAboutClick}
                    aria-label="關於我們"
                >
                    <i className="fas fa-info-circle"></i>
                    <span>關於我們</span>
                </button>
            </div>
        </>
    );
};

export default MobileMenu;

